import { apiDelete, apiGet, apiPost, apiPut } from './client';
import type { NotificationList } from '../types';

// REAL backend calls to /api/notifications.
export function fetchNotifications(): Promise<NotificationList> {
  return apiGet<NotificationList>('/notifications');
}

export function markNotificationRead(id: number): Promise<unknown> {
  return apiPut(`/notifications/${id}/read`);
}

export function markAllNotificationsRead(): Promise<unknown> {
  return apiPut('/notifications/read-all');
}

export function archiveNotification(id: number): Promise<unknown> {
  return apiPut(`/notifications/${id}/archive`);
}

export function deleteNotification(id: number): Promise<unknown> {
  return apiDelete(`/notifications/${id}`);
}

// --- Firebase Cloud Messaging device registration ---
export function registerDevice(token: string, platform = 'web'): Promise<unknown> {
  return apiPost('/notifications/devices', { token, platform });
}

export function unregisterDevice(token: string): Promise<unknown> {
  return apiDelete(`/notifications/devices/${encodeURIComponent(token)}`);
}

export function subscribeToTopic(topic: string): Promise<unknown> {
  return apiPost('/notifications/subscribe', { topic });
}
